import React, { useState } from "react";
import { Text } from "@networkraildigitalfactory/components";
import { CaretDown, CaretUp } from "phosphor-react";
import CommentList from "../CommentList/CommentList";
import styles from "./AuditTrail.module.css";

const AuditTrail = (props) => {
  const [showAuditTrail, setShowAuditTrail] = useState(false);
  const toggleAuditTrail = () => {
    setShowAuditTrail(!showAuditTrail);
    setTimeout(() => {
      document.getElementById("hiddenScroller").scrollIntoView(false);
    }, 10);
  };

  return (
    <div className={styles.AuditTrail}>
      <div className={styles.row}>
        <Text
          wrapper="h3"
          type="subtitle"
          style={{ fontSize: "20px", lineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Audit trail
        </Text>
        <button
          type="button"
          className={styles.toggle}
          name="toggle audit trail"
          aria-label="toggle-audit-trail"
          onClick={toggleAuditTrail}
        >
          {showAuditTrail ? (
            <CaretUp size={24} color="#37519d" weight="bold" />
          ) : (
            <CaretDown size={24} color="#37519d" weight="bold" />
          )}
        </button>
      </div>
      {showAuditTrail && <CommentList data={props.data} type="audit" />}
      <span id="hiddenScroller" className={styles.hidden}>
        Scroll audits into view
      </span>
    </div>
  );
};

export default AuditTrail;
